export default __webpack_public_path__ + "static/media/fixedAmountDiscountAfterThreshold.f65c7dda.webp";